module.exports = __webpack_public_path__ + "img/32.bbec190c.jpg";